<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
        <div class="form-group" [formGroup]="form">
            <app-action-alert controlName="weight" [alerts]="item!.actionAlerts" [form]="form"></app-action-alert>
            <app-unit-quantity label="Weight" unitLabel="kg" placeholder="Value" inputMode="decimal" formControlName="weight"></app-unit-quantity>
        </div>
        <app-common-action-controls [action]="action" [form]="form"></app-common-action-controls>
    </div>
</app-action-form>
